import React, { useMemo } from 'react';
import Loading from '../../components/globales/Loading';
import TablaLayout from '../../components/globales/TablaLayout';
import ModalDynamic from '../../components/globales/ModalDynamic';
import useCrud from '../../hooks/useCrud';
import ENDPOINTS from '../../api/endpoints';
import { hostSchema } from '../../services/validators';

export default function Host() {
    const hostEndpoints = useMemo(() => ({
        listar: ENDPOINTS.hosts.listar,
        crear: ENDPOINTS.hosts.crear,
        actualizar: ENDPOINTS.hosts.actualizar,
        borrar: ENDPOINTS.hosts.borrar
    }), []);

    const keyField = 'codigo'; 
    const initForm = () => ({
        url: '',
        estado: true,
        descripcion: ''
    });

    // Función para renderizar estado con badge (igual que en Manifiestos)
    const renderEstado = (estado) => {
        return (
            <span className={`badge ${estado ? 'bg-success' : 'bg-danger'}`}>
                {estado ? 'Activo' : 'Inactivo'}
            </span>
        );
    };

    // Función para transformar los datos antes de enviarlos al servidor
    const transformRequest = (data) => {
        return {
            ...data,
            estado: Boolean(data.estado) // Asegurar que estado sea booleano
        };
    };

    const estadoOptions = [
        { value: 'true', label: 'Activo' },
        { value: 'false', label: 'Inactivo' }
    ];

    const tableColumns = [
        { label: 'No', key: 'index', align: 'center', render: (_, idx) => idx + 1 },
        { label: 'URL', key: 'url', width: '40%' },
        { 
            label: 'Estado', 
            key: 'estado', 
            width: '20%', 
            options: estadoOptions,
            render: (_, idx, item) => {
                // Manejar tanto el valor directo como el objeto completo
                const estadoValue = typeof item === 'object' && item !== null ? item.estado : item;
                const truthy = estadoValue === true || estadoValue === 'true' || estadoValue === 1 || estadoValue === '1';
                return renderEstado(truthy);
            }
        },
        { label: 'Descripción', key: 'descripcion', width: '30%' }
    ];

    const modalColumns = [
        { label: 'URL', key: 'url', width: '40%', type: 'text', placeholder: 'Ingrese la URL del host' },
        { label: 'Estado', key: 'estado', width: '20%', options: estadoOptions,
            render: (value, _, __, accion) => {
                if (accion === 'consultar') {
                    const truthy = value === true || value === 'true' || value === 1 || value === '1';
                    return renderEstado(truthy);
                }
                return value; // Para crear/editar, devolver el valor original
            }
        },
        { label: 'Descripción', key: 'descripcion', width: '30%' }
    ];

    const breadcrumbs = [
        { label: 'Inicio', href: '/inicio' },
        { label: 'Host' }
    ];

    const {
        data,
        loading,
        error,
        showModal,
        actionType,
        formData,
        errors,
        loadingModal,
        openModal,
        closeModal,
        handleChange,
        submit,
        remove
    } = useCrud(hostEndpoints, { 
        keyField, 
        initForm, 
        columns: modalColumns, 
        schema: hostSchema, 
        transformRequest 
    });

    if (loading) return <Loading mensaje="Cargando Host..." />;
    if (error) return <div className="text-danger">Error: {error.message}</div>;

    return (
        <div className="container">
            <TablaLayout
                title="Host"
                data={data}
                columns={tableColumns}
                keyField={keyField}
                onCreate={() => openModal('crear')}
                onView={item => openModal('consultar', item)}
                onEdit={item => openModal('editar', item)}
                onDelete={remove}
                disableDelete={item => item.registros_encuestas > 0}
                showConsult={false}
                breadcrumbs={breadcrumbs}
            />

            <ModalDynamic
                show={showModal}
                accion={actionType}
                title="Host"
                columns={modalColumns}
                formData={formData}
                errors={errors}
                loading={loadingModal}
                onChange={handleChange}
                onSubmit={submit}
                onClose={closeModal}
            />
        </div>
    );
}
